module.exports = __webpack_public_path__ + "static/img/powered_by_weel_4-white.97dccb6.svg";